import { Select, Space, Tag } from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

export default function RoleFilter(props) {
  const supabase = getSupaClient();
  const [roleTags, setRoleTags] = useState([]);
  const [roleTagsId, setRoleTagsId] = useState([]);
  const [teamRoles, setTeamRoles] = useState([]);

  console.log("roleTags:", roleTags);
  console.log("roleTagsId:", roleTagsId);

  const { Option } = Select;

  /**
   * This will load all the roles for a given guild
   */
  const loadTeamRoles = async () => {
    const { data, error } = await supabase
      .from("discord_roles")
      .select("discord_id, name")
      .eq("guild", props.guildId);

    if (data) {
      console.log("roles data:", data);
      setTeamRoles(data);
    }
    if (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    loadTeamRoles();
  }, []);

  // This will try to find the selected role tag in the set of of all role tags
  function returnRoleObj(value) {
    return teamRoles.find((item) => item.discord_id === value);
  }

  // This will render the role tag in the Select input (the filter's dropdown)
  function roleTagRender(payload) {
    const { onClose, closable, value } = payload;
    if (payload.value) {
      const roleTag = roleTags.find(
        (element) => element.discord_id === payload.value
      );
      if (roleTag) {
        return (
          <Tag
            closable={closable}
            onClose={onClose}
            style={{ marginRight: 3 }}
            key={value}
          >
            {roleTag.name}
          </Tag>
        );
      }
      return null;
    }
    return null;
  }

  /**
   * This will update the selected role tags each time the user clicks on one
   * in the role tags selection modal
   *
   * @param {*} selection - the selected tag by the user
   */
  const onSelect = async (selection) => {
    const selectedRoleTag = returnRoleObj(selection);
    const newRoleTags = roleTags.concat(selectedRoleTag);
    const newRoleTagsIds = newRoleTags.map((item) => item.discord_id);
    setRoleTags(newRoleTags);
    setRoleTagsId(newRoleTagsIds);
    props.onChange({
      filter_type: "roles",
      filter_settings: { roles: newRoleTagsIds },
    });
  };

  /**
   * This will update the selected role tags anytime the user deselects one
   * in the role tags selection modal
   *
   * @param {*} selection - The selected role
   */
  const onDeselect = async (selection) => {
    const remainingTags = roleTags.filter(
      (roleTag) => roleTag.discord_id !== selection
    );
    const remainingTagsIds = remainingTags.map((item) => item.discord_id);
    setRoleTags(remainingTags);
    setRoleTagsId(remainingTags.map((item) => item.discord_id));
    if (remainingTagsIds.length === 0) {
      props.onChange({ filter_type: "roles" });
    } else {
      props.onChange({
        filter_type: "roles",
        filter_settings: { roles: remainingTagsIds },
      });
    }
  };

  return (
    <>
      <Space>
        <span>Select roles: </span>
        <Select
          mode="multiple"
          showArrow
          tagRender={roleTagRender}
          value={roleTagsId}
          style={{ width: "500px", borderRadius: 10 }}
          onSelect={onSelect}
          onDeselect={onDeselect}
          optionFilterProp="name"
        >
          {teamRoles.map((item) => {
            return (
              <Option
                key={item.discord_id}
                value={item.discord_id}
                name={item.name}
              >
                <Tag style={{ width: "fit-content" }}>{item.name}</Tag>
              </Option>
            );
          })}
        </Select>
      </Space>
    </>
  );
}
